export default __webpack_public_path__ + "images/T4.4142920.png";